import Router from 'next/router';

/** @deprecated This function should not be used any more. It should be deleted and getABTestGroup changed to
 * get and store ABTest info off the query string. However, it is still used by MultistepV5.ts, which is a disused
 * AB test group. MultistepV5 won't exist after plasmic enter-flow goes in the bin
 */
export const getTestGroupFromQueryOrStorage = <T extends string>(
  testName: string,
  validGroups: T[],
): T | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const query = Router.query;

  if (
    query.test &&
    query.test === testName &&
    query.testGroup &&
    validGroups.includes(query.testGroup as T)
  ) {
    // This stores the test group in a different key to doABTestWithDistribution. I assume this is deliberate, as using
    // a query string manually forces an AB test group. It also does not cause a tracking event to occur for the
    // test group selection
    localStorage.setItem(query.test, query.testGroup as string);
    return query.testGroup as T;
  }

  const storedTestGroup = localStorage.getItem(testName);
  if (storedTestGroup && validGroups.includes(storedTestGroup as T)) {
    return storedTestGroup as T;
  }

  return null;
};
